import { AuthProvider } from '../auth/AuthContext';
import { TravelLocaleProvider } from './TravelLocaleContext';
import AppRouter from './router';

export default function App() {
  return (
    <TravelLocaleProvider>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </TravelLocaleProvider>
  );
}
